import { AmzonImgURL, MyBlockWrapper } from '../../component/common'
import { MZSearchDialog } from '../../component/azsearch/azsearch'
import {FontSizeList } from '../../component/data'
import { MdlImagePickerNew } from '../../component/MdlImagePicker'
import { WidthSize } from '../../component/fields/widthSize'


const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { Button, FontSizePicker, TextControl, ToggleControl, PanelBody } = wp.components;
const { InspectorControls, MediaUpload, MediaUploadCheck, RichText, PanelColorSettings } = wp.blockEditor;
const { useEffect, useState } = wp.element
const { has} = lodash

registerBlockType('themesfirst/i2-azon-image', {
    title: __('Image i2AZON', 'themesfirst'),
    icon: 'format-image',
    category: 'themesfirst',
    keywords: [
        __('Image', 'themesfirst'),
        __('Amazon Image', 'themesfirst'),
        __('i2 azon', 'themesfirst'),
    ],
    attributes: {
        item_ids: {
            type: 'array',
            default: []
        },
        products: {
            type: 'array',
            default: []
        },
        block_id: {
            type: 'string',
            default: ''
        },
        link: {
            type: 'string',
            default: ''
        },
        alt_text: {
            type: 'string',
            default: ''
        },
        text: {
            type: 'string',
            default: __('CLICK HERE', 'themesfirst')
        },
        showText: {
            type: 'boolean',
            default: true
        },
        textOnTop: {
            type: 'boolean',
            default: false
        },
        useBorder: {
            type: 'boolean',
            default: false
        },
        borderColor: {
            default: '#231f20'
        },
        paddingSize: {
            type: 'string',
        },
        fontSize: {
            type: 'number',
            default: 18
        },
        color: {
            default: '#ffffff'
        },
        bgColor: {
            default: '#231f20'
        },
        useLink: {
            type: 'boolean',
            default: true
        },
        customLink: {
            type: 'string',
            default: ''
        },
        width: {
            type: 'object',
            default: {
                size: 400,
                unit: 'px',
                full: 780
            }
        },
    },
    supports: {
        align: true
    },
    edit: (props) => {
        // console.log("==================================");
        //console.log(props);

        const { attributes, clientId, attributes: { item_ids, width, block_id, useLink, customLink,alt_text, paddingSize, useBorder, borderColor, active_image_index, products, custom_img, link, text, color, bgColor, fontSize, showText, textOnTop }, setAttributes } = props;

        if (block_id == '' || block_id == undefined) {
            setAttributes({ block_id: clientId });
        }

        // const [colors, setColors] = useState([
        //     {
        //         value: bgColor,
        //         onChange: (colorValue) => setAttributes({ bgColor: colorValue }),
        //         label: __('Background Color', 'themesfirst'),
        //     },
        //     {
        //         value: color,
        //         onChange: (colorValue) => setAttributes({ color: colorValue }),
        //         label: __('Text Color', 'themesfirst'),
        //     }
        // ]);

        // useEffect(() => {

        //     if (!useBorder && colors.length > 2) {

        //         colors.pop();
        //         setColors([...colors]);

        //     } else if (useBorder && colors.length == 2) {

        //         colors.push(
        //             {
        //                 value: borderColor,
        //                 onChange: (colorValue) => setAttributes({ borderColor: colorValue }),
        //                 label: __('Border Color', 'themesfirst')
        //             }
        //         );
        //         setColors([...colors]);
        //     }
        // }
        //     , [useBorder]);

        const updateData = (obj) => {
            if (has(obj, 'item_ids')) {
                setAttributes(obj)
            } else {
                if (obj.products.length == 1) {
                    setAttributes({ products: [{ asin: obj.products[0].asin, title:obj.products[0].title, image: obj.products[0].image }] });
                    if(alt_text == ''){
                        let text = obj.products[0].title;
                        if(text.length > 70){
                           let i = text.lastIndexOf(' ',70);
                            text = text.substring(0, i);
                        }
                        setAttributes({alt_text : text});  
                    }
                }
            }
        }


        const updateImages = (prodPos, image) => {

            const obj = [...products];
            obj[prodPos]['image'] = image;
            setAttributes({ products: obj })

        }
        const updateCustomImage = (pos, val) => {
            // console.log(pos)
            // console.log(val)
            const obj = [...products];
            //console.log(obj[pos]);
            //	obj[pos]['mytest'] = val;

            obj[pos]['custom_img'] = val;
            //	console.log(obj[pos]);
            // obj[pos]['customImg']["mediaUrl"] = val.mediaUrl;
            setAttributes({ products: obj })
        }
        const removeCustomImage = (pos) => {
            //     console.log("inside custom");
            if (has(products[pos], 'custom_img')) {
                const obj = [...products];
                delete obj[pos]['custom_img'];
                setAttributes({ products: obj });
            }
        }
        const logAttr = () => {
            // const allImages = wp.apiFetch({ path: "/i2-azon/v1/search/my keyworeds" })
            // .then((data)=>log(data));
            //log(features.filter(x=>x.visiable).map(x=> x.id));
            console.log(attributes);
        }

        const updateValue = (obj) => {
            setAttributes(obj);
        }

        return (<>
            <InspectorControls>
                <PanelBody title={__("Common", 'themesfirst')}
                    initialOpen={true} >
                    {/* <Button onClick={logAttr} > Log Attr </Button> */}
                    <MZSearchDialog item_ids={item_ids} products={products} updateValue={updateData} isSingle={true} />
                    <hr />
                    {item_ids.length > 0 && <h4>{__('ASIN', 'themesfirst')} : {item_ids[0]} </h4>}
                    <WidthSize field={width} onChange={obj => setAttributes({ width: obj })} />
                    <hr />
                    <ToggleControl label={__("Use Link?", 'themesfirst')}
                        checked={useLink}
                        onChange={() => setAttributes({ useLink: !useLink })}
                    />
                    {useLink && <> <TextControl
                        label={__("Alt Text", 'themesfirst')}
                        help={__("Image alt text", 'themesfirst')}
                        value={alt_text}
                        onChange={(val) => setAttributes({ alt_text: val })}
                    />
                        <TextControl
                            label={__("URL (By default amazon link)", 'themesfirst')}
                            help={__("Optional (custom url should start with http)", 'themesfirst')}
                            value={customLink}
                            onChange={(val) => setAttributes({ customLink: val })}
                        />
                    </>
                    }
                    <ToggleControl
                        label="Show Text?"
                        checked={showText}
                        onChange={() => setAttributes({ showText: !showText })}
                    />
                    {showText && <ToggleControl
                        label="Text On Top?"
                        help={textOnTop ? 'Text on top.' : 'Text on bottom'}
                        checked={textOnTop}
                        onChange={() => setAttributes({ textOnTop: !textOnTop })}
                    />}
                    <ToggleControl label={__("Use Border?", 'themesfirst')}
                        checked={useBorder}
                        onChange={() => setAttributes({ useBorder: !useBorder })}
                    />
                </PanelBody>
                <PanelBody title={__("Font Size", 'themesfirst')}
                    initialOpen={false} >
                    <FontSizePicker
                        fontSizes={FontSizeList}
                        value={fontSize}
                        fallbackFontSize={18}
                        withSlider={true}
                        onChange={(newFontSize) => {
                            setAttributes({ fontSize: newFontSize ? newFontSize : 18 });
                        }}
                    />
                </PanelBody>
                <PanelColorSettings
                    title={__('Color Settings', 'themesfirst')}
                    initialOpen={false}
                    colorSettings={useBorder ? [
                        {
                            value: bgColor,
                            onChange: (colorValue) => setAttributes({ bgColor: colorValue !== undefined ? colorValue : '#231f20' }),
                            label: __('Background Color', 'themesfirst'),
                        },
                        {
                            value: color,
                            onChange: (colorValue) => setAttributes({ color: colorValue !== undefined ? colorValue : '#ffffff' }),
                            label: __('Text Color', 'themesfirst'),
                        },
                        {
                            value: borderColor,
                            onChange: (colorValue) => setAttributes({ borderColor: colorValue !== undefined ? colorValue : '#231f20' }),
                            label: __('Border Color', 'themesfirst')
                        }
                    ] : [
                            {
                                value: bgColor,
                                onChange: (colorValue) => setAttributes({ bgColor: colorValue !== undefined ? colorValue : '#231f20' }),
                                label: __('Background Color', 'themesfirst'),
                            },
                            {
                                value: color,
                                onChange: (colorValue) => setAttributes({ color: colorValue !== undefined ? colorValue : '#ffffff' }),
                                label: __('Text Color', 'themesfirst'),
                            }
                        ]}
                >
                </PanelColorSettings>
            </InspectorControls>

            <figure className="tf-i2 tf-i2-azon-image mywp-block-image" style={{ position: "relative", width: width.unit == '%a' ? "100%" : width.size + width.unit }}>
                <div className="components-resizable-box__container has-show-handle" style={{ "position": "relative", "boxSizing": "border-box", "width": "100%" }}>
                    {products.length == 0 && <MZSearchDialog item_ids={item_ids} products={products} updateValue={updateData} isSingle={true} />}
                    {products.map((prod, j) => {
                        return (<div className={(useBorder ? "has-border " : "") + "tf-amz-image-wrapper"} style={{ flexDirection: textOnTop ? "column-reverse" : "column", borderColor: borderColor }}>
                            {!has(prod, 'custom_img.mediaId') && (
                                <MdlImagePickerNew image={prod['image']} asin={prod['asin']} prodPos={j} updateImages={updateImages} size={width.unit != 'px' ? null : width.size} />)}
                            <div className={prod['custom_img'] == undefined || prod['custom_img'] == "" ? "no-custom-image" : "editor-post-featured-image"}>
                                {prod['custom_img'] != undefined && <img src={prod['custom_img'].mediaUrl} />}
                                <MediaUploadCheck>
                                    <MediaUpload onSelect={obj => updateCustomImage(j, { mediaId: obj.id, mediaUrl: obj.url })}
                                        value={prod['custom_img'] != undefined && prod['custom_img'] != "" ? prod['custom_img'].mediaId : ""}
                                        allowedTypes={['image']}
                                        render={({ open }) => (
                                            <Button icon="wordpress" isSecondary size="24" className="no-custom-image" onClick={open}>
                                            </Button>
                                        )}
                                    />
                                </MediaUploadCheck>
                                {has(prod, 'custom_img.mediaId') && <Button icon="trash" className="clear-custom-image" iconSize="24" label="Delete" onClick={() => removeCustomImage(j)}></Button>}
                            </div>
                            {showText && <div style={{ clear: 'both', marginTop: '0', backgroundColor: bgColor, color: color, textAlign: 'center' }}>
                                <RichText onChange={obj => setAttributes({ text: obj })}
                                    tagName="p"
                                    value={text}
                                    style={{ margin: 0, fontSize: fontSize + "px", lineHeight: (fontSize * 2) + "px" }}
                                />
                            </div>}
                        </div>)
                    })}
                </div>
            </figure>
        </>
        )
    },
    save: (props) => {
        const { attributes: { block_id, width, useLink,alt_text, text, bgColor, color, fontSize, useBorder, products, textOnTop, showText, borderColor }} = props;
        // console.log(props);
        return (products && products.length > 0 && <MyBlockWrapper isLink={useLink} elm="div" id={`tf-block-image-${block_id}`} className={`tf-block-${block_id} tf-amz-image-block-wrapper`} href="##AFFILIATELINK##" target="_blank" rel="nofollow noopener noreferrer" style={{ width: width.size + width.unit}}>
            <div className={(useBorder ? "has-border " : "") + "tf-amz-image-wrapper"} style={{ flexDirection: textOnTop ? "column-reverse" : "column", borderColor: borderColor }}>
                <div className="tf-featured-media">
                    {products.length == 1 && !has(products[0], 'custom_img.mediaId') && <img src={AmzonImgURL(products[0]['image'].URL, width.unit == "px" && width.size <= products[0]['image'].Width ? width.size : "", products[0]['image'].EXT)} alt={alt_text}  height={products[0]['image'].Height} width={products[0]['image'].Width} />}{products.length == 1 && has(products[0], 'custom_img.mediaId') && <img src={products[0]['custom_img']['mediaUrl']} alt={alt_text} />}</div>
                {showText && <div style={{ clear: 'both', marginTop: '0', backgroundColor: bgColor, textAlign: 'center' }}>
                    <p style={{ margin: 0, fontSize: fontSize + "px", color: color, lineHeight: (fontSize * 2) + "px" }}>{text}</p>
                </div>}
            </div>
        </MyBlockWrapper>)
    }
});
